import {roleCompare} from '../../helpers/functions';
import store from 'app/store';
import {configureActivityTracking, logoutSession} from 'helpers/session';
export const loginActions = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT',
};

function resolveLoginErrorMessage(response, responseBody) {
  const bodyMessage =
    typeof responseBody === 'string' ? responseBody : responseBody?.message;

  if (bodyMessage && String(bodyMessage).trim()) {
    return bodyMessage;
  }

  if (response?.status === 400) {
    return 'Usuario y/o contraseña incorrectos';
  }

  if (response?.status === 503) {
    return 'No se pudo establecer conexión con la base de datos. Intente nuevamente en unos minutos.';
  }

  return 'Error al iniciar sesión. Intente nuevamente más tarde.';
}

export async function login(user, pass) {
  store.dispatch({type: loginActions.LOGIN_REQUEST, user});
  const controller = 'Auth';
  const action = 'Authenticate';
  let response = null;
  let responseBody = null;
  let networkError = false;
  var values = {user: user, pass: pass};
  await fetch(`api/${controller}/${action}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(JSON.stringify(values)),
  })
    .then(async (res) => {
      response = res;
      const text = await res.text();
      try {
        return text ? JSON.parse(text) : null;
      } catch (e) {
        return text;
      }
    })
    .then((resBody) => {
      responseBody = resBody;
      if (response.ok) {
        // Compatibilidad: backend puede devolver user anidado o en raíz
        let userObj = resBody.user || resBody;
        const requirePasswordChange = Boolean(
          resBody?.requirePasswordChange ??
          resBody?.RequirePasswordChange ??
          userObj?.requirePasswordChange ??
          userObj?.RequirePasswordChange,
        );
        const array = userObj.roles ? userObj.roles.sort(roleCompare) : [];
        const newArrayOfUser = {...userObj, roles: [...array]};
        sessionStorage.setItem('user', JSON.stringify(newArrayOfUser));
        configureActivityTracking(newArrayOfUser);
        if (requirePasswordChange) {
          sessionStorage.setItem('requirePasswordChange', 'true');
        } else {
          sessionStorage.removeItem('requirePasswordChange');
        }
        store.dispatch({type: loginActions.LOGIN_SUCCESS, user: userObj});
      } else {
        const errMsg = resolveLoginErrorMessage(response, resBody);
        store.dispatch({
          type: loginActions.LOGIN_FAILURE,
          error: errMsg,
        });
      }
    })
    .catch((error) => {
      console.error(error);
      networkError = true;
      store.dispatch({
        type: loginActions.LOGIN_FAILURE,
        error: 'Error de conexión con la red',
      });
    });

  let loginStatus;
  if (!response || networkError) {
    loginStatus = {ok: false, text: 'Error de conexión con la red'};
  } else {
    loginStatus = {
      ok: response.ok,
      text: response.ok
        ? 'Autenticación correcta'
        : resolveLoginErrorMessage(response, responseBody),
    };
  }
  return loginStatus;
}

export function logout() {
  logoutSession('manual', false);
}
